import { Discount } from 'store/resource/types';
import { DAYS_ORDER } from 'components/discounts-list/discounts-list.constants';

export const getCurrentHighestDiscount = (startDate: string, discounts: Array<Discount>): Discount | null => {
  if (!discounts?.length) {
    return null;
  }

  const date = new Date(startDate as string);
  const dayOfWeek = DAYS_ORDER[date.getUTCDay()];

  const availableDiscounts = discounts.filter(discount => discount.daysApplied.includes(dayOfWeek));

  if (availableDiscounts.length === 0) {
    return null;
  }

  return availableDiscounts.reduce((max, discount) => (discount.amount > max.amount ? discount : max));
};
